module.exports = __webpack_public_path__ + "static/media/mastercard.9667db45.png";